import { render, staticRenderFns } from "./BWeekdayspicker.vue?vue&type=template&id=5453e995&"
import script from "./BWeekdayspicker.vue?vue&type=script&lang=js&"
export * from "./BWeekdayspicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports